export default __webpack_public_path__ + "static/glass-1.0-scheda-tecnica-113467915b362635604829612f8fc99d.pdf";